<template>
  <router-view></router-view>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {},
  mounted() {},
  created() {
    // let nav = document.createElement("script"); //创建script标签
    // nav.type = "text/javascript";
    // nav.src = require("@/utils/initRem.js"); //静态资源
  },
};
</script>

<style>
* {
  box-sizing: border-box;
}
</style>
